module.exports = __webpack_public_path__ + "img/cancercouncil-nsw.7d2573c.png";